import React from 'react';
import { AlertCircle } from 'lucide-react';




const formatDisplayDate = (date) => {
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  return date.toLocaleDateString('en-US', options);
};



const CancelModal = ({ booking, onConfirm, onClose }) => {
  if (!booking) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl p-6 max-w-md w-full">
        <div className="flex items-center mb-4">
          <AlertCircle className="text-red-600 mr-2" size={24} />
          <h3 className="text-lg font-semibold text-gray-800">Cancel Booking</h3>
        </div>
        
        <p className="text-gray-600 mb-4">
          Are you sure you want to cancel your booking for{' '}
          <span className="font-semibold">{formatDisplayDate(booking.date)}</span>?
        </p>
        
        <div className="bg-gray-50 p-3 rounded-lg mb-4">
          <div className="text-sm text-gray-600 space-y-1">
            <div><strong>Name:</strong> {booking.name}</div>
            <div><strong>People:</strong> {booking.people}</div>
            <div><strong>Phone:</strong> {booking.phone}</div>
          </div>
        </div>
        
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 bg-gray-200 text-gray-800 py-2 rounded-lg font-semibold hover:bg-gray-300 transition-colors"
          >
            Keep Booking
          </button>
          <button
            onClick={() => onConfirm(booking)}
            className="flex-1 bg-red-600 text-white py-2 rounded-lg font-semibold hover:bg-red-700 transition-colors"
          >
            Cancel Booking
          </button>
        </div>
      </div>
    </div>
  );
};


export default CancelModal;